import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  border-radius: 8px;

  &:hover {
    cursor: pointer;
  }
`;
